(() => {
  if (customElements.get('hr-product')) return;
  class HaleemProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('[data-variant-select]');
      this.quantity = this.querySelector('[name="quantity"]');
      this.naanSelect = this.querySelector('[data-naan-select]');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.portionIndex = Number(this.dataset.portionIndex);
      this.naanIndex = Number(this.dataset.naanIndex);
      this.money = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.dataset.currency });
      this.querySelector('[data-variant-fallback]').hidden = true;
      const cards = this.querySelector('[data-variant-cards]');
      cards.hidden = cards.hasAttribute('data-single-variant');
      this.querySelectorAll('[data-minus],[data-plus],[data-tabs]').forEach(el => el.hidden = false);
      this.querySelectorAll('[data-panel]').forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', (panel.dataset.panel === 'description' ? 'DescriptionTab-' : 'AllergensTab-') + this.dataset.section);
      });
      this.showTab('description');
      this.addEventListener('click', event => {
        const portion = event.target.closest('[data-portion]');
        const thumbnail = event.target.closest('[data-thumbnail]');
        const tab = event.target.closest('[data-tab]');
        if (portion) { this.portion = portion.dataset.portion; this.chooseOptions(true); }
        if (thumbnail) this.showImage(thumbnail.dataset.thumbnail);
        if (tab) this.showTab(tab.dataset.tab);
        if (event.target.closest('[data-minus]')) { this.quantity.stepDown(); this.updateQuantity(); }
        if (event.target.closest('[data-plus]')) { this.quantity.stepUp(); this.updateQuantity(); }
      });
      this.naanSelect?.addEventListener('change', () => this.chooseOptions(true));
      this.quantity.addEventListener('change', () => this.updateQuantity());
      this.querySelector('[data-tabs]').addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const active = this.querySelector('[data-tab][aria-selected="true"]').dataset.tab;
        const next = event.key === 'Home' ? 'description' : event.key === 'End' ? 'allergens' : active === 'description' ? 'allergens' : 'description';
        this.showTab(next);
        this.querySelector(`[data-tab="${next}"]`).focus();
      });
      const initial = this.variants.find(variant => String(variant.id) === this.select.value) || this.variants[0];
      this.portion = initial.options[this.portionIndex];
      if (this.naanSelect) this.naanSelect.value = initial.options[this.naanIndex];
      this.chooseVariant(initial, false);
    }
    findVariant(portion, naan) {
      return this.variants.find(variant => variant.options[this.portionIndex] === portion &&
        (this.naanIndex < 0 || variant.options[this.naanIndex] === naan));
    }
    chooseOptions(updateUrl) {
      const variant = this.findVariant(this.portion, this.naanSelect?.value);
      if (variant) this.chooseVariant(variant, updateUrl);
    }
    chooseVariant(variant, updateUrl) {
      this.select.value = String(variant.id);
      this.querySelectorAll('[data-portion]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.portion === this.portion)));
      this.querySelector('[data-price]').textContent = this.money.format(variant.price / 100);
      const add = this.querySelector('[data-add]');
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to cart' : 'Sold out';
      this.quantity.min = String(variant.min);
      this.quantity.step = String(variant.step);
      if (variant.max) this.quantity.max = String(variant.max);
      else this.quantity.removeAttribute('max');
      this.quantity.value = this.quantity.min;
      this.updateQuantity();
      if (variant.image) this.showImage(String(variant.image));
      this.updateNaans();
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    updateQuantity() {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      let value = Number(this.quantity.value);
      if (!Number.isFinite(value) || value < min) value = min;
      value = min + Math.floor((Math.min(value, max) - min) / step) * step;
      this.quantity.value = String(value);
      this.querySelector('[data-minus]').disabled = value <= min;
      this.querySelector('[data-plus]').disabled = value + step > max;
    }
    updateNaans() {
      if (!this.naanSelect) return;
      // Label each choice with its extra cost over the portion's no-naan price.
      const base = this.findVariant(this.portion, this.naanSelect.options[0].value);
      for (const option of this.naanSelect.options) {
        const variant = this.findVariant(this.portion, option.value);
        const extra = variant && base ? variant.price - base.price : 0;
        option.disabled = !variant || !variant.available;
        option.textContent = option.dataset.label +
          (extra > 0 ? ` (+${this.money.format(extra / 100)} per portion)` : '') +
          (variant && !variant.available ? ' — Sold out' : '');
      }
    }
    showImage(id) {
      if (!id || !this.querySelector(`[data-image="${id}"]`)) return;
      this.querySelectorAll('[data-image]').forEach(el => el.hidden = el.dataset.image !== id);
      this.querySelectorAll('[data-thumbnail]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.thumbnail === id)));
    }
    showTab(name) {
      this.querySelectorAll('[data-tab]').forEach(el => el.setAttribute('aria-selected', String(el.dataset.tab === name)));
      this.querySelectorAll('[data-panel]').forEach(el => el.hidden = el.dataset.panel !== name);
    }
  }
  customElements.define('hr-product', HaleemProduct);
})();
